export default __webpack_public_path__ + "static/media/placeholder-firstServe-logo.9c3b29da.svg";